import { render } from "./MainPanel.vue?vue&type=template&id=44a0a0a6&scoped=true&ts=true"
import script from "./MainPanel.vue?vue&type=script&lang=ts"
export * from "./MainPanel.vue?vue&type=script&lang=ts"

import "./MainPanel.vue?vue&type=style&index=0&id=44a0a0a6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/RECA/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a0a0a6"]])

export default __exports__